import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { CheckCircle2, ArrowRight, Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export default function SuccessPage() {
  const { profile, refreshProfile } = useAuth();
  const [polling, setPolling] = useState(true);

  useEffect(() => {
    let cancelled = false;
    let attempts = 0;
    const tick = async () => {
      attempts += 1;
      await refreshProfile();
      if (cancelled) return;
      if ((profile?.plan && profile.plan !== 'free') || attempts >= 10) {
        setPolling(false);
        return;
      }
      setTimeout(tick, 1500);
    };
    tick();
    return () => {
      cancelled = true;
    };
  }, [refreshProfile, profile?.plan]);

  const planLabel = profile?.plan && profile.plan !== 'free' ? profile.plan.charAt(0).toUpperCase() + profile.plan.slice(1) : null;

  return (
    <div className="min-h-screen grid place-items-center bg-warm-50 px-6">
      <div className="card max-w-lg w-full p-10 text-center">
        <div className="w-14 h-14 rounded-full bg-accent-50 grid place-items-center mx-auto mb-5">
          <CheckCircle2 className="w-7 h-7 text-accent-600" />
        </div>
        <h1 className="font-display text-3xl mb-3">You're all set.</h1>
        {planLabel ? (
          <p className="text-ink-600 mb-8">Welcome to PromptGPT {planLabel}. Your plan is active.</p>
        ) : polling ? (
          <p className="text-ink-600 mb-8 inline-flex items-center gap-2 justify-center">
            <Loader2 className="w-4 h-4 animate-spin" /> Activating your subscription...
          </p>
        ) : (
          <p className="text-ink-600 mb-8">Your payment was received. If your plan does not appear, refresh in a moment.</p>
        )}
        <Link to="/learn" className="btn-primary">Go to today's lesson <ArrowRight className="w-4 h-4" /></Link>
      </div>
    </div>
  );
}
